import PropTypes from 'prop-types';

import { ColumnHeaderFilterButton } from './ColumnHeaderFilterButton';

export const ColumnHeaderFilterSlot = ({
  field,
  formattedColumns,
  filterModelItems,
  onFilterModelChange,
  withTransparentHeader,
}) => {
  const currentColumn = formattedColumns.find((column) => column.field === field);
  const filterField = currentColumn?.filterField || field;
  const valueOptions =
    typeof currentColumn?.valueOptions === 'function'
      ? currentColumn.valueOptions({ field })
      : currentColumn?.valueOptions;

  if (!currentColumn?.filterable || !valueOptions?.length) {
    return null;
  }

  return (
    <ColumnHeaderFilterButton
      field={filterField}
      headerName={currentColumn?.headerName}
      filterType={currentColumn?.filterPanelType}
      valueOptions={valueOptions}
      filterValue={filterModelItems.find((item) => item.field === filterField)?.value}
      onFilterModelChange={onFilterModelChange}
      withTransparentHeader={withTransparentHeader}
    />
  );
};

ColumnHeaderFilterSlot.propTypes = {
  field: PropTypes.string.isRequired,
  formattedColumns: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  filterModelItems: PropTypes.arrayOf(
    PropTypes.shape({
      field: PropTypes.string,
      value: PropTypes.oneOfType([PropTypes.string, PropTypes.arrayOf(PropTypes.string)]),
    }),
  ).isRequired,
  onFilterModelChange: PropTypes.func.isRequired,
  withTransparentHeader: PropTypes.bool.isRequired,
};
